import { INumericInputProps, NumericInput } from "@blueprintjs/core";
import { IWidgetProps } from "decorator-form";

interface INumberWidgetProps extends IWidgetProps<number> {
	options?: Partial<INumericInputProps>;
}

export default function NumberWidget(props: INumberWidgetProps) {
	const { options = {} } = props;

	return (
		<NumericInput
			{...options}
			onValueChange={props.onChange}
			value={props.value}
			disabled={props.disabled}
			required={props.required}
			readOnly={props.readonly}
		/>
	);
}

NumberWidget.withOptions = (options: Partial<INumericInputProps>) => {
	return (props: IWidgetProps<number>) => <NumberWidget {...props} options={options} />;
};

NumberWidget.Positive = NumberWidget.withOptions({min: 0});



// WEBPACK FOOTER //
// ./src/common/form/widgets/NumberWidget.tsx